import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { HeaderActions, Segmented } from './ui/dg';

/**
 * Section à onglets (Notifications : Push / E-mails ; Journaux : API /
 * Historique). L'onglet vit dans l'URL (`?vue=…`) : un lien ou un
 * rechargement retombe au même endroit. Le premier onglet est celui par
 * défaut et n'apparaît pas dans l'adresse.
 */

export interface SectionView {
  id: string;
  label: string;
  /** Petite étiquette à côté du libellé (« Expérimental »). */
  badge?: string;
  render: () => React.ReactNode;
}

interface SectionTabsProps {
  views: SectionView[];
  ariaLabel: string;
}

const SectionTabs = ({ views, ariaLabel }: SectionTabsProps) => {
  const [params, setParams] = useSearchParams();
  const current = views.find((v) => v.id === params.get('vue')) || views[0];

  const select = (id: string) => {
    const updated = new URLSearchParams(params);
    if (id === views[0].id) updated.delete('vue'); else updated.set('vue', id);
    setParams(updated, { replace: true });
  };

  // Les onglets vont dans l'en-tête, à côté du titre (docs/backoffice).
  return (
    <div className="flex-1 flex flex-col min-h-0 bg-[#F7F7FB]">
      <HeaderActions>
        <Segmented ariaLabel={ariaLabel} options={views.map((v) => ({ id: v.id, label: v.label, badge: v.badge }))} value={current.id} onChange={select} />
      </HeaderActions>
      {/* Sur petit écran l'en-tête n'a pas la place : les onglets restent ici. */}
      <div className="px-4 pt-2 lg:hidden">
        <Segmented ariaLabel={ariaLabel} options={views.map((v) => ({ id: v.id, label: v.label, badge: v.badge }))} value={current.id} onChange={select} />
      </div>
      {current.render()}
    </div>
  );
};

export default SectionTabs;
